//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import get from 'lodash/get';

import { PLACEHOLDER_IMG } from '../../constants/global';

export default {
  name: 'BrowseResults',

  props: {
    deals: {
      type: Array,
      required: true,
    },
    isFilterable: {
      type: Boolean,
      required: false,
      default: false,
    },
    session: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      placeholderImg: PLACEHOLDER_IMG,
    };
  },
  methods: {
    get,
    selectFilter(filter) {
      this.$emit('filterSelect', filter);
    },
    intersected(dealId) {
      this.$impressions.add(dealId);
    },
  },
  serverCacheKey: ({ session, deals = [] }) => {
    // generate server cache key based off of deal data that may influence markup
    const keys = deals.map((deal) => [
      deal.id,
        deal.dates?.start_date,
        deal.dates?.end_date,
        deal.buy_button?.is_last_call,
        deal.participation.join('!'),
        deal.browse_deal_status,
    ]);

    // if the user is logged in these *may* influence markup now or in the future
    if (session.user) {
      keys.push(session.user.has_plus);
      keys.push(session.user.has_briefcase);
      keys.push(session.user.is_betaling);
      keys.push(session.user.is_staff);
    }

    // campaigns can influence markup on deal banners, etc
    if (session.campaigns) {
      keys.push(session.campaigns.join('!'));
    }

    return `BrowseResults::${keys.filter(Boolean).join(',')}`;
  },
};
